import React from 'react';

/**
 * SwitchVisual: Componente reutilizable de switch visual tipo toggle.
 * Props:
 * - label: string (texto a mostrar al lado del switch)
 * - checked: boolean (estado del switch)
 * - onChange: function (callback al cambiar el estado)
 * - disabled: boolean (opcional)
 * - style: object (opcional, estilos extra para el contenedor)
 * - labelStyle: object (opcional, estilos extra para el label)
 */
export default function SwitchVisual({ label, checked, onChange, disabled = false, style = {}, labelStyle = {}, labelPosition = 'right', labelClassName = '' }) {
  const switchContainerStyle = {
    position: 'relative',
    width: '40px',
    height: '20px',
    backgroundColor: 'white',
    border: `2px solid ${checked ? 'green' : 'red'}`,
    borderRadius: '20px',
    cursor: disabled ? 'not-allowed' : 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: checked ? 'flex-end' : 'flex-start',
    padding: '2px',
    transition: 'all 0.3s ease',
    marginRight: '10px',
    opacity: disabled ? 0.6 : 1,
    ...style
  };
  const knobStyle = {
    width: '14px',
    height: '14px',
    backgroundColor: checked ? 'green' : 'red',
    borderRadius: '50%',
    transition: 'all 0.3s ease'
  };
  const defaultLabelStyle = {
    marginBottom: '0',
    fontWeight: 'bold',
    color: '#333',
    cursor: disabled ? 'not-allowed' : 'pointer',
    userSelect: 'none',
    ...labelStyle
  };
  return (
    <div className="d-flex align-items-center">
      {label && labelPosition === 'left' && (
        <label
          className={labelClassName}
          style={{ ...defaultLabelStyle, marginRight: 8 }}
          onClick={e => {
            e.preventDefault();
            if (!disabled && onChange) onChange(!checked);
          }}
        >
          {label}
        </label>
      )}
      <div
        style={switchContainerStyle}
        onClick={e => {
          e.preventDefault();
          if (!disabled && onChange) onChange(!checked);
        }}
      >
        <div style={knobStyle} />
      </div>
      {label && labelPosition !== 'left' && (
        <label
          className={labelClassName}
          style={defaultLabelStyle}
          onClick={e => {
            e.preventDefault();
            if (!disabled && onChange) onChange(!checked);
          }}
        >
          {label}
        </label>
      )}
    </div>
  );
}
